<template>
</template>
<script type="text/javascript">

export default {
	name: "DoCompanyForm",
	methods: {
		doForm(slug) {
			const vm = this

			const params = { fields: ['id'] }

			this.getJSON('FormChildTemplate/find/' + slug, params).then(response => {
				if (response.success) {
					const payload = {
						doChildTemplateIdList: [response.data.id]
					}
					vm.$bus.$emit("doCompanyForm", payload)
					if (this.$store.userDetails && 'slug' in this.$store.userDetails && this.$store.userDetails.slug)
						this.$router.push("/employee/" + this.$store.userDetails.slug + "/forms")
				} else {
					vm.alertFail("Form Child Template not found")
				}
			})
		}
	},
	created() {
		if ('child_template_slug' in this.$route.params && this.$route.params.child_template_slug)
			this.doForm(this.$route.params.child_template_slug)
	}
}
</script>